import { NavigationEnd, Router, Event, ActivatedRoute } from '@angular/router';
import { Component, ElementRef, HostListener, Inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { I18nService } from './modules/i18n/i18n.service';
import { trigger, state, transition, style, animate } from '@angular/animations';
import { DOCUMENT } from '@angular/common';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations:[
    trigger('fade',
    [
      state('void', style({ opacity : 0})),
      transition(':enter',[ animate(300)]),
      transition(':leave',[ animate(500)]),
    ]
)]
})
export class AppComponent implements OnInit {
  title = 'covid-frontend-web';
  hideHeaderFooter = false;
  public carouselItems: any =  [];
  isIntl = environment.international;
  currLang = 'en';
  currUrl = '';

  constructor(
    private router: Router,
    private titleService: Title,
    private translate: TranslateService,
    private myElement: ElementRef,
    private activatedRoute: ActivatedRoute,
    private i18nService: I18nService,
    @Inject(DOCUMENT) document: Document,
  ) {
      this.activatedRoute.queryParams.subscribe( (params: any) => {
        if(params && params['lang']) {
          this.i18nService.language = params['lang'];
        }
      });
  }



  ngOnInit(): void {
    this.currLang = this.translate.currentLang;
    this.translate.onLangChange.subscribe( (r: any) => {
      this.currLang = this.translate.currentLang;
      this.titleService.setTitle(this.translate.instant('TITLE'));
    });
    this.initializeCarouselObj();
    this.router.events.subscribe((event: Event) => {
      // console.log('router.events.subscribe', r);
      if (event instanceof NavigationEnd) {
        console.log(event.url);
        this.currUrl = event.url;
        if (event.url == '/error') {
          this.hideHeaderFooter = true;
        }
        const regex = new RegExp('/#');
        if (event.url!= '/' || !regex.test(event.url)) {
          window.scrollTo(0, 0);
        }
      }

    });

  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e:any) {
    if (window.pageYOffset > 100) {
      let element:any = document.getElementById('navbar');
      element.classList.add('sticky');
    } else {
     let element:any = document.getElementById('navbar');
       element.classList.remove('sticky');
    }
  }

  initializeCarouselObj(): void {
    this.carouselItems = [
      {imageUrl: 'assets/images/slide1.jpg', caption: ''},
      {imageUrl: 'assets/images/slide1.jpg', caption: ''},
      {imageUrl: 'assets/images/slide1.jpg', caption: ''},
      {imageUrl: 'assets/images/slide1.jpg', caption: ''}
    ];
  }

  ngAfterViewInit(): void {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        console.log(event.url);
        const regex = new RegExp('#');
        if (regex.test(event.url)) {
          const idPath = this.getStrAfter(event.url, '#');
          // console.log(idPath);
          setTimeout(() => {
            // const el = this.myElement.nativeElement.querySelector(idPath);
            // el.scrollIntoView({behavior: 'smooth'});
            const scrollTo = document.getElementById(idPath);
            const topHight = this.getOffset(scrollTo).top;
            window.scrollTo(0, topHight);
          }, 500);

        }
      }

    });
  }

  getStrAfter(str: any, delimiter: any) {
    if (delimiter === '') {
      return str;
    }
    const substrings = str.split(delimiter);
    return substrings.length === 1
      ? str // delimiter is not part of the string
      : substrings.slice(1).join(delimiter);
  }

  getOffset(el: any) {
    el = el.getBoundingClientRect();
    return {
       left: el.left + window.scrollX,
       top: el.top + window.scrollY,
       bottom: el.top + window.scrollY
    }
  }
}
